import PageState from '../../Shared/pageState';
import { WorkflowEngineState } from '../workflowEngineReducer';

export default (state: WorkflowEngineState, newPage: PageState) => {
  state.pages.forEach((page: PageState) => {
    if (page.id === newPage.id) {
      page.controls = newPage.controls;
      return;
    }
  });
  return { ...state };
};
